/* RESPONSIBLE TEAM: team-workflows */
import type SummarizeConversation from 'embercom/models/operator/visual-builder/step/summarize-conversation';
import StepConfig, { type StepConfigParams } from '../step';

export default class SummarizeConversationConfiguration extends StepConfig {
  declare step: SummarizeConversation;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/summarize-conversation',
      ...params,
    });
  }
}
